// ** Icons Import
import { Icon } from '@iconify/react/dist/iconify.js';

export default [
    {
        id: 'project',
        title: 'Project',
        icon: <Icon icon="clarity:design-solid" height={20} width={20} />,
        navLink: '/project'
    }
];
